export default __webpack_public_path__ + "static/media/white-text-measure-icon.450c4a96.svg";